<template>
    <div class="header">
        <div class="row wrapper">
            <div class="col-md-4">
                <div class="btn-dashboard pointer" v-if="isProject" @click="$router.push({ name: 'projectSelection' });">
                    <span class="mr-2"><font-awesome-icon :icon="['fa', 'angle-left']" /></span>
                    Project
                </div>

                <div class="btn-dashboard pointer" v-if="isDashboard"  @click="$router.push({ name: 'dashboard' });">
                    <span><img src="../assets/img/icon-dashboard.svg" alt="icon-dashboard" /></span>
                    dashboard
                </div>
            </div>

            <div class="col-md-4">
                <div class="project-name">
                    {{ projectTitle }}
                </div>
            </div>

            <div class="col-md-4">
                <div class="user-detail">
                    <span class="icon-user">
                        <font-awesome-icon :icon="['far', 'user']" />
                    </span>
                    <span class="welcome">Welcome, </span>
                    <span class="username">{{ username }}</span>
                    <span class="pointer" @click="$router.push({ name: 'login' });">LOGOUT</span>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        isDashboard: Boolean,
        projectTitle: String,
        username: String,
        isProject: Boolean
    }
}
</script>

<style scoped>
.header {
    width: 100%;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
}

.header .wrapper {
    margin: 20px;
    padding: 15px 0;
    border-radius: 5px;
    background-color: #2B4162;
    box-shadow: 0 3px 6px rgba(0,0,0,0.1);
}

.header .project-name {
    text-align: center;
}

.header .user-detail {
    text-align: right;
}

.header .icon-user {
    margin-right: 10px;
}

.header .welcome {
    text-transform: capitalize;
    font-weight: 400;
}

.header .username {
    text-transform: capitalize;
    margin-right: 30px;
}

.header .btn-dashboard img {
    margin-right: 5px;
    margin-top: -2px;
}

@media (max-width: 767px) {
    .header , .header *, .header .user-detail {
        text-align: center;
    }

    .header div[class^="col"] {
        margin-bottom : 5px;
    }
}
</style>